import { BoxProps } from 'shared/mui/Box';
import { Table, TableBodyProps, TableProps } from 'shared/mui/Table';

import { StyledBox, StyledTableBody } from './CardTable.styled';

export type CardTableProps = {
  tableProps?: TableProps;
  tableBodyProps?: TableBodyProps;
  children: React.ReactNode;
} & BoxProps;

export const CardTable: React.FC<CardTableProps> = ({
  children,
  tableProps,
  tableBodyProps,
  ...restProps
}) => (
  <StyledBox {...restProps}>
    <Table {...tableProps}>
      <StyledTableBody {...tableBodyProps}>{children}</StyledTableBody>
    </Table>
  </StyledBox>
);
